import { cx } from '@linaria/core';
import { useState } from 'react';
import { Pm2Icon } from '@pm2/react-utils';
import { hasMegaMenu } from '@pm2/sitemap-utils';
import { pm2ConfigStore } from '@pm2/store';
import { Link } from '@provider/navigation';
import { printHtmlToJsx, simpleHtmlParsers } from '@utils/ast';
import { useLoaderState, Chevron } from '@utils/react';
import { useOpenMegaMenu } from '../MegaMenu/hook.open-mega-menu.js';
import { wrapperCls, listCls, itemCls, itemIconCls, linkCls } from './List.style.js';
import { stateWrapperCls, throbberCls, throbberWrapperCls, chevronCls } from './Navigation.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const List = ({
  listRef,
  items,
  activeRootPage,
  onLinkClick
}) => {
  return /*#__PURE__*/jsx("div", {
    className: wrapperCls,
    ref: listRef,
    children: /*#__PURE__*/jsx("ul", {
      className: listCls,
      children: items.map(item => /*#__PURE__*/jsx(Item, {
        item: item,
        activeRootPage: activeRootPage,
        onLinkClick: onLinkClick
      }, item.id))
    })
  });
};
const Item = ({
  item,
  activeRootPage,
  onLinkClick
}) => {
  const openMegaMenu = useOpenMegaMenu("default");
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const [isLoading, setLoading] = useState(false);
  const showThrobber = useLoaderState(isLoading);
  const onMegaMenuOpen = async item => {
    setLoading(true);
    try {
      await openMegaMenu(item, {
        isMobile: true
      });
      onLinkClick();
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
  const enableLinkIcon = audience === "Grade1To3" || audience === "Grade4To6";
  return /*#__PURE__*/jsx("li", {
    className: itemCls,
    children: hasMegaMenu(item) ? /*#__PURE__*/jsxs("button", {
      className: cx(linkCls, activeRootPage === item && "active"),
      onClick: () => {
        onMegaMenuOpen(item);
      },
      children: [enableLinkIcon && item.topNavIcon && /*#__PURE__*/jsx("span", {
        className: itemIconCls,
        children: /*#__PURE__*/jsx(Pm2Icon, {
          ident: item.topNavIcon,
          size: 24,
          strokeWidth: 1.15
        })
      }), printHtmlToJsx(item.title, simpleHtmlParsers), /*#__PURE__*/jsxs("span", {
        className: stateWrapperCls,
        children: [/*#__PURE__*/jsx("span", {
          className: cx(throbberWrapperCls, !showThrobber.current && "hidden"),
          children: /*#__PURE__*/jsx("span", {
            className: throbberCls
          })
        }), /*#__PURE__*/jsx("span", {
          className: cx(chevronCls, showThrobber.current && "hidden"),
          children: /*#__PURE__*/jsx(Chevron, {
            vertical: true,
            size: 6,
            lineWidth: 1.5
          })
        })]
      })]
    }) : /*#__PURE__*/jsxs(Link, {
      href: item.path,
      className: cx(linkCls, activeRootPage === item && "active"),
      onClick: onLinkClick,
      children: [enableLinkIcon && item.topNavIcon && /*#__PURE__*/jsx("span", {
        className: itemIconCls,
        children: /*#__PURE__*/jsx(Pm2Icon, {
          ident: item.topNavIcon,
          size: 24,
          strokeWidth: 1.15
        })
      }), printHtmlToJsx(item.title, simpleHtmlParsers)]
    })
  }, item.id);
};

export { List };
//# sourceMappingURL=List.js.map
